import { render, staticRenderFns } from "./AssignmentPreview.vue?vue&type=template&id=76fbd7aa&scoped=true&"
import script from "./AssignmentPreview.vue?vue&type=script&lang=ts&"
export * from "./AssignmentPreview.vue?vue&type=script&lang=ts&"
import style0 from "./AssignmentPreview.vue?vue&type=style&index=0&id=76fbd7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fbd7aa",
  null
  
)

export default component.exports